import * as home from './home.js'
import * as course from './course.js'
import * as personal from './personal.js'
import * as message from './message.js'
import * as examination from './examination.js'
import * as practice from './practice.js'
export default {
  home,
  course,
  personal,
  message,
  examination,
  practice
}
